import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { FaCheck } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import { ShowGiftDetails, PublishGift, EditGift } from "../../components";
import { Stack } from "@mui/material";
import { translateToArabic } from "../localize/englishToArabic";
import DeleteGift from "../../components/pagesComponents/gifts/DeleteGift";

export const getGiftsCols = (onGiftUpdated?: () => void): GridColDef[] => [
    {
        field: "type",
        headerName: "نوع الهدية",
        width: 150,
        sortable: false,
        filterable: false,
        valueGetter: (params) => params.row?.gift_type?.name ?? "لا يوجد",
    },
    {
        field: "compensate_type",
        headerName: "النوع ",
        width: 150,
        sortable: false,
        filterable: false,
        valueGetter: (params) =>
            params.row?.compensate_type
                ? translateToArabic(`gifts_${params.row?.compensate_type}`)
                : "لا يوجد",
    },
    {
        field: "valid_from",
        headerName: "متاح من",
        width: 150,
        sortable: false,
        filterable: false,
        valueGetter: (params) =>
            params.row?.valid_from
                ? dayjs(params.row?.valid_from).format("YYYY/MM/DD")
                : "لا يوجد",
    },
    {
        field: "valid_to",
        headerName: "متاح الى",
        width: 150,
        sortable: false,
        filterable: false,
        valueGetter: (params) =>
            params.row?.valid_to
                ? dayjs(params.row?.valid_to).format("YYYY/MM/DD")
                : "لا يوجد",
    },
    {
        field: "affected_users",
        headerName: "المستخدمين المتاحين",
        width: 150,
        sortable: false,
        filterable: false,
    },
    {
        field: "is_published",
        headerName: "تم نشره",
        width: 100,
        sortable: false,
        filterable: false,
        renderCell: (params: GridRenderCellParams<any>) => {
            return params?.row?.is_published ? (
                <FaCheck style={{ color: "green" }} />
            ) : (
                <FaTimes style={{ color: "red" }} />
            );
        },
    },
    {
        field: "actions",
        headerName: "مشاهدة",
        width: 350,
        sortable: false,
        filterable: false,
        renderCell: (params: GridRenderCellParams<any>): React.ReactNode => (
            <Stack direction="row" spacing={1}>
                <ShowGiftDetails gift={params.row} />
                <EditGift gift={params.row} onGiftUpdated={onGiftUpdated} />
                <PublishGift gift={params.row} />
                <DeleteGift id={params?.row?.id} />
            </Stack>
        ),
    },
];

// For backward compatibility, export a default columns array
export const giftsCols = getGiftsCols();
